// src/theme/strings.ts
// Every user-facing string, grouped by screen. Screens render registry
// keys only — copy edits and future localization happen here.
export const strings = {
  onboarding: {
    intentTitle: "What do you want to build?",
    intentSubtitle: "Pick a path — you can switch anytime.",
    buildCardTitle: "Build an app",
    buildCardSub: "Describe it and we'll create a starter you can preview.",
    browseCardTitle: "Try example apps",
    browseCardSub: "Explore ready-made demo apps to see what Saddle can build.",
    personalCardTitle: "Just for me",
    personalCardSub: "A private app only you use — your data stays yours.",
    sharableCardTitle: "For others",
    sharableCardSub: "Customers or a team can use it; you can publish it.",
    shareFeatureTitle: "Let others sign in & use it",
    shareFeatureSub: "Adds user accounts, roles, and lets you publish it.",
    signInPrompt: "Already have an account?",
    signInAction: "Sign in",
    typeTitle: "What kind of app?",
    typeNext: "Next",
    describeTitle: "What should it do?",
    describePlaceholder: "e.g. track my workouts with sets, reps and progress",
    describeNext: "Next",
    nameTitle: "Name your app",
    namePlaceholder: "My App",
    nameNext: "Continue",
  },
  paywall: {
    title: "Unlock more",
    // Shown only when the balance really is empty.
    subtitle:
      "You've used your free credits. Subscribe to keep editing and building.",
    // The common case since charging moved BEFORE the work: there are credits left, just
    // not enough for this action. Saying "you've used your credits" while the header
    // behind the sheet shows a positive number is a small lie in the place that asks for
    // money.
    //
    // A template rather than a function: every leaf of this registry has to be a non-empty
    // string, and `registries.test.ts` is right to enforce that — a function here would
    // make "is this copy missing?" unanswerable for the whole tree.
    subtitleShort:
      "This costs {needed} credits and you have {remaining}. Subscribe to keep editing and building.",
    price: "$20",
    per: "/month · 20,000 credits",
    cta: "Subscribe",
    processing: "Processing…",
    restore: "Restore purchase",
    disclosure:
      "Auto-renews monthly until cancelled. Payment is charged to your App Store account at confirmation; manage or cancel anytime in Settings at least 24 hours before renewal.",
    // The App Store wording is wrong in a browser — there is no App Store account and
    // no Settings screen to cancel in.
    disclosureWeb:
      "Auto-renews monthly until cancelled. Payment is charged to your card securely by Stripe; cancel anytime from your account.",
    signInRequired:
      "Sign in first so your subscription lands on the right account.",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
    dismiss: "Not now",
    unavailable: "In-app purchases aren’t available in this build yet.",
    success: "You're subscribed! Your credits have been added.",
    failed: "Purchase failed. Please try again.",
    nothingToRestore: "No previous purchase found to restore.",
  },
  apps: {
    discoverEmptyTitle: "Nothing here yet",
    discoverEmptyBody: "No apps published yet. Build one and tap Publish!",
    myAppsEmptyTitle: "No apps yet",
    myAppsEmptyBody: "Find one in Discover and tap Get.",
    get: "Get",
    open: "Open",
  },
  tabs: {
    build: "Build",
    discover: "Discover",
    myApps: "My Apps",
  },
  account: {
    a11yAvatar: "Account",
  },
} as const;
